module.exports = __webpack_public_path__ + "img/apps_mail_img.0c577160.svg";